import { Injectable } from '@angular/core';
import { BehaviorSubject, from, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Platform } from '@ionic/angular';
import { BackButtonEmitter } from '@ionic/angular/common/providers/platform';

@Injectable({
    providedIn: 'root',
})
export class PlatformService {
    public isIosPlatform$ = from(this.platform.ready()).pipe(map(() => this.platform.is('ios')));
    public pausePlatform$ = new Subject<void>();
    public resumePlatform$ = new Subject<void>();
    constructor(private platform: Platform) {}

    public init() {
        from(this.platform.ready()).subscribe(() => {
            this.platform.pause.subscribe(() => {
                this.pausePlatform$.next();
            });
            this.platform.resume.subscribe(() => {
                this.resumePlatform$.next();
            });
        });
    }

    public backButton(): BackButtonEmitter {
        return this.platform.backButton;
    }
}
